import Axios from "axios";

export class ClientePjService {

    getLista(params) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/cliente-pj/lista?${queryParams}`).then(res => res.data);
    }

    nuevoCliente(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/trust/cliente-pj/nuevo`, data).then(res => res.data);
    }

    editarCliente(data) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/ficha/trust/cliente-pj/editar`, data).then(res => res.data);
    }

    eliminarCliente(id) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/ficha/trust/cliente-pj/eliminar/${id}`).then(res => res.data);
    }

    consultarCliente(id, opciones = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/cliente-pj/consulta/${id}`, { params: opciones }).then(res => res.data);
    }

    descargar(id, opciones = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/cliente-pj/reporte/${id}`, {
            params: opciones,
            headers: { 'Content-Type': 'application/json', 'Pragma': 'no-cache' }, responseType: 'blob'
        }).then(async res => res.data);
    }

    getArbolAnexos(id, opciones = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/cliente-pj/arbol-anexos/${id}`, { params: opciones }).then(res => res.data);
    }
}
